export { default as bind } from './bind.ts';
export { default as bindSync } from './bindSync.ts';
export { default as call, default } from './call.ts';
export { default as callSync } from './callSync.ts';
export type * from './types.ts';
